import CUPSDetailPage from './CUPSDetailPage';

export default CUPSDetailPage;
